import * as Yup from 'yup';

export const addShippingAddressSchema = Yup.object().shape({
  addressLineOne: Yup.string().required('Address is required'),
  zipCode: Yup.string().required('Zip / Postal Code is required'),
  country: Yup.string().required('Country is required'),
});
